import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useAPiFrameworksOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isApiFrameworksLoading,
    data: apiFrameworks,
    refetch: refetchApiFrameworks,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch api framework options'),
    optionType: OptionsType.VIDEO_API_FRAMEWORK,
    queryOptions,
  });

  return {
    apiFrameworks,
    isApiFrameworksLoading,
    refetchApiFrameworks,
  };
}
